"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const context_1 = require("./context");
const CampaignPage_1 = require("../../../../../routes/Private/Emails/EmailEditor/CampaignPage");
exports.CampaignSendPage = ({ blocks, html, email, onEmailChange, goBack, onBlocksChange, toggleEmailEditButton, }) => {
    return (react_1.default.createElement(context_1.CampaignSendPageContext.Provider, { value: {} },
        react_1.default.createElement(CampaignPage_1.CampaignPage, { blocks: blocks, html: html, viewType: "sendCampaign", setViewType: () => { }, toggleEmailEditButton: toggleEmailEditButton, email: email, onBlocksChange: onBlocksChange, goBack: goBack, onEmailChange: onEmailChange })));
};
//# sourceMappingURL=CampaignSendPage.js.map